import { render, staticRenderFns } from "./AboutMargin.vue?vue&type=template&id=0d56d4f2&scoped=true&"
import script from "./AboutMargin.vue?vue&type=script&lang=js&"
export * from "./AboutMargin.vue?vue&type=script&lang=js&"
import style0 from "./AboutMargin.vue?vue&type=style&index=0&id=0d56d4f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56d4f2",
  null
  
)

export default component.exports